"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RtfCommentsImporter = void 0;
var tslib_1 = require("tslib");
var importer_base_1 = require("./importer-base");
var RtfCommentsImporter = (function (_super) {
    tslib_1.__extends(RtfCommentsImporter, _super);
    function RtfCommentsImporter(data) {
        return _super.call(this, data) || this;
    }
    RtfCommentsImporter.prototype.insertComments = function () {
    };
    RtfCommentsImporter.prototype.pushState = function () {
    };
    RtfCommentsImporter.prototype.popState = function () {
    };
    RtfCommentsImporter.prototype.startImportSubDocument = function () {
    };
    RtfCommentsImporter.prototype.finalizeSubDocument = function () {
        this.insertComments();
    };
    return RtfCommentsImporter;
}(importer_base_1.RtfBaseImporter));
exports.RtfCommentsImporter = RtfCommentsImporter;
